import { ModalitaPagamentoService } from '../../../../../services/data/modalita-pagamento.service';

export const PaymentModeSelector = {
    template: require('./payment-mode-selector.html'),
    controller: class PaymentModeSelector {

        static $inject: string[] = [
            'ModalitaPagamentoService'
        ];

        private modalitaPagamentoTypes: Record<string, string>;

        constructor(
            modalitaPagamentoService: ModalitaPagamentoService
        ) {
            this.modalitaPagamentoTypes = modalitaPagamentoService.getTypes();
        }
    },
    bindings: {
        name: '@',
        model: '='
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/component/payment-mode-selector/payment-mode-selector.ts